// PLUS ACSE LANDING PAGES

// usuwanie 'plus.pl' lub 'https://' i wszystkiego co przed tymi stringami ORAZ usuwanie wszystkiego co po '?' z linka
// https://liberty.eu/ -> liberty.eu
// https://www.plus.pl/abonament?process=mig -> /abonament
export default function preparedGALink(link: string): string {
    const tmp = link.includes('?') ? link.slice(0, link.indexOf('?')) : link
    return tmp.replace(/^(.*plus\.pl|.*https:\/\/)/, '')
}
